const fetchRequest = (url, options = {}) => (
    new Promise((resolve, reject) => {
        jQuery.ajax(url, options).done(resolve).fail(reject);
    })
);

export default fetchRequest;



// WEBPACK FOOTER //
// ./src/scripts/components/common/fetchRequest.js